// removed by extract-text-webpack-plugin
module.exports = {"container":"_31ycYHNU7UYxvxCchXvEFe"};


//////////////////
// WEBPACK FOOTER
// ./src/App/Pages/Documents/ViewerDocuments/styles.css
// module id = 2724
// module chunks = 0